<template>
  <div
    class="Footer"
    v-if="showFooter"
    :class="[language == 'zh' ? 'zhFamily' : 'enfamily']"
  >
    <div class="Footer_color_bar">
      <!-- <img src="../../../assets/image/Public/colorBar.png" alt="" /> -->
    </div>
    <div class="Footer_box">
      <!-- Color Bar -->

      <!-- Center -->
      <div class="Footer_center">
        <!-- logo -->
        <div class="Footer_logo">
          <div class="Footer_logo_box">
            <img
              class="footer_img1"
              src="../../../assets/image/Logo/home_side_bar.png"
              alt
            />
            <img
              class="footer_img3"
              src="../../../assets/image/Logo/home_side_bar_sdg.png"
              alt
            />
          </div>
          <div class="Footer_logo_content_us">
            <div class="img_wx">
              <img src="../../../assets/image/Public/QR1.jpg" alt />
              <!-- {{$t('PublicComponents.Footer.WeChat')}} -->
            </div>

            <div style="width:500px">
              <p style="fontWeight:600;color:#fff;fontSize:18px"> {{ $t("PublicComponents.Footer.WeChat") }}</p>
             
              <p>
                {{ $t("PublicComponents.Footer.Address") }}：{{
                  $t("PublicComponents.Footer.AddressInfo")
                }}
              </p>
               <p>
                {{
                  $t("PublicComponents.Footer.Email")
                }}：secretariat@cbas.ac.cn
              </p>
               <p>
                {{
                  $t("PublicComponents.Footer.Postcode")
                }}：100094
              </p>
               <p>
                {{
                  $t("PublicComponents.Footer.Phone")
                }}：010-82177823
              </p>
            </div>
          </div>
        </div>
        <!-- 导航 相关链接 -->
        <div class="Footer_nav">
          <ul >
            <li class="title">{{ $t("PublicComponents.Footer.Nav") }}</li>
            <li class="li" @click="toPath('/datahub')">
              {{ $t("PublicComponents.Footer.DataHub") }}
            </li>
            <li class="li" @click="toPath('/newslist?type=Society')">
              {{ $t("PublicComponents.Footer.Society") }}
            </li>
            <li class="li" @click="toPath('/newslist?type=Technology')">
              {{ $t("PublicComponents.Footer.Science") }}
            </li>
            <li class="li" @click="toPath('/newslist?type=Case')">
              {{ $t("PublicComponents.Footer.Practices") }}
            </li>
            <li class="li" @click="toPath('/sdgsindicators')">
              {{ $t("PublicComponents.Footer.Knowledge") }}
            </li>
          </ul>
          <ul>
            <li class="title">{{ $t("PublicComponents.Footer.Link") }}</li>
      <li class="li">
              <a href="http://portal.casearth.cn/" target="_bank">{{
                $t("PublicComponents.Footer.Link2")
              }}</a>
            </li>
            <li class="li">
              <a href="http://www.casearth.com" target="_blank">{{
                $t("PublicComponents.Footer.Link1")
              }}</a>
            </li>

      
            <li class="li">
              <a href="http://www.cbas.ac.cn/" target="_blank">{{
                $t("PublicComponents.Footer.Link3")
              }}</a>
            </li>


       
            <li class="li">
              <a
                href="https://sdg.casearth.cn/"
                target="_bank"
                >{{ $t("PublicComponents.Footer.Link4") }}</a
              >
            </li>
            <!-- <li class="li">
              <a href="http://www.cnic.cas.cn/" target="_bank">{{
                $t("PublicComponents.Footer.Link5")
              }}</a>
            </li> -->
          </ul>
        </div>
      </div>
      <!-- copyright -->
      <div class="copyright">
        <p>{{ $t("PublicComponents.Footer.Copyright") }} &nbsp; &nbsp; &nbsp;  {{$t("PublicComponents.Footer.Copyright2")}}</p>
 
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  data() {
    return {
      showFooter: true,
    };
  },
  methods: {
    toPath(path) {
      this.$router.push(path);
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        // to.path == "/login"|| to.path == "/register" || to.path == "/forget"
        if (to.path == "/appMaket2") {
          this.showFooter = false;
        } else {
          this.showFooter = true;
        }
      },

      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
};
</script>

<style scoped lang="scss">
.zhFamily {
  font-family: $zhFamily;
}
.enfamily {
  font-family: $enFamily;
}
.Footer {
  width: 100%;
  background: #3d3f4d;
  display: flex;
  flex-direction: column;

  .Footer_box {
    width: 1280px;
    margin: auto;
    padding: 80px 0 20px 0;
    display: flex;
    flex-direction: column;
    .Footer_center {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .Footer_logo {
        display: flex;
        flex-direction: column;
        width: 616px;
        .Footer_logo_box {
          margin: 0 0 0px 0;
          .footer_img1 {
            width: 146px;
            height: 76px;
          }
          .footer_img3 {
            margin-left: 43px;
            width: 71px;
            height: 71px;
          }
        }
        .Footer_logo_content_us {
          margin-top: 16px;
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          .img_wx {
            width: 130px;
            margin-right: 20px;
            color: #ccc;
            font-size: 14px;
          }
          img {
            width: 130px;
            height: 130px;
          }
          p {
            color: #ccc;
            line-height: 28px;
            font-size: 14px;
          }
        }
      }
      .Footer_nav {
        display: flex;
        flex-direction: row;

        ul {
          margin-left: 50px;
          .title {
            color: #fff;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 10px;
          }

          .li {
            color: #ccc;
            font-size: 16px;
            line-height: 40px;
            // height: 22px;;
            min-width: 180px;
                max-width: 380px;
                white-space: nowrap;
            background-image: linear-gradient(#999, #999);
            background-position: center bottom;
            background-repeat: no-repeat;
                    text-overflow: ellipsis;
        overflow: hidden;

            transition: background-size 0.3s
              cubic-bezier(0.55, 0.085, 0.68, 0.53);
            text-decoration: none;
            background-size: 0 2px;
            a {
              color: #ccc;
            }
            &:hover {
              // font-size: 16px;
              text-decoration: none;
              transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
              background-size: 100% 2px;
              cursor: pointer;
            }
          }
        }
      }
    }
    .copyright {
      padding-top: 20px;
      width: 1280px;
      margin: auto;
      p {
        padding-top: 20px;
        border-top: 1px solid #555;
        color: #a8afdd;
        opacity: 0.5;
        line-height: 30px;
        font-size: 16px;
        text-align: center;
      }
    }
  }
  .Footer_color_bar {
    background: url("../../../assets/image/Public/colorBar.png");
    height: 10px;
    width: 100%;
  }
}
</style>